<template>
  <div class="activities-form">
    <div class="row">
      <div class="col-12">
        <div v-if="error" class="alert alert-danger mb-2">
            {{error.message}}
        </div>
        <span v-if="formStep === 1">
          <div class="row">
            <div class="col-12 text-center" style="margin-bottom: 10px">
              <span v-if="icons">
                <span v-bind:key="activityIcon.icon_id" v-on:click="setIdIcon(activityIcon.icon_id)" v-for="activityIcon in icons">
                  <activity-icon :id="activityIcon.icon_id" :height="'65px'" style="margin: 10px"></activity-icon>
                </span>
              </span>
            </div>

            <div class="col-12" v-if="activityType === null && idIconActivityTypes">
              <div class="d-grid gap-2" >
                  <button class="btn btn-secondary" v-for="item in idIconActivityTypes.filter((x) => x.name !== '')" v-bind:key="item.id" v-on:click="setActivityType(item)">{{ item.name }}</button>
              </div>
            </div>
            <div class="col-12" v-else-if="activityType">
              <h5 class="fw-bold">{{ activityType.name }}</h5>
            </div>

            <div v-if="idIcon == 9" class="col-12">
              <p class="alert alert-info">
                LET OP: Dit is een bijzondere activiteit! 
                Deze activiteit is bedoeld om een chatbericht te sturen naar meerdere kinderen tegelijk.
                Deze berichten komen dan ook niet (langer) in het logboek maar komen in de chat van het betreffende kind.
              </p>
            </div>
            <div v-if="activityType" class="col-12">
              <label>Omschrijving</label>
              <textarea-plus-two v-model="text" placeholder="Omschrijving..."></textarea-plus-two>
              <label>Standaardteksten</label>
              <select v-if="activityType.predefined_texts && activityType.predefined_texts.length > 0" v-model="selectedPredefinedText" class="form-control">
                <option :value="null">Geen standaardtekst gebruiken</option>
                <option v-bind:key="item.id" v-for="item in activityType.predefined_texts" :value="item.text">
                  {{ item.text }}
                </option>
              </select>
              <select v-else class="form-control" disabled>
                <option>Geen standaardtekst beschikbaar</option>
              </select>
              <div class="row">
                <div class="col-12 col-sm-6">
                  <label v-if="activityType.enter_time_end === true">Van</label>
                  <label v-else>Tijd</label>
                  <time-picker :initTime="timeStart" @selectTime="setStartTime($event)"></time-picker>
                </div>
                <div v-if="activityType.enter_time_end === true" class="col-12 col-sm-6">
                  <label>Tot</label>
                  <time-picker :initTime="timeEnd" @selectTime="setEndTime($event)"></time-picker>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                   <label>Datum</label>
                  <date-picker @setDate="setDate($event)" :initDate="this.date"></date-picker>
                </div>
              </div>
            </div>
          </div>
        </span>
        <span v-if="formStep === 2">
          <child-select @onSelect="setChildren($event)"></child-select>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import ActivityIcon from '@/components/Activity-Icon'
import TextareaPlusTwo from '@/components/Textarea-Plus-Two'
import ChildSelect from '@/components/Child-Select'
import TimePicker from '@/components/Time-Picker.vue'
import DatePicker from '@/components/Date-Picker'
export default {
  name: 'activities-form',
  components: {
    ActivityIcon,
    TextareaPlusTwo,
    ChildSelect,
    TimePicker,
    DatePicker
  },
  props: ['formStep', 'saveActivity', 'activity', 'child'],
  data () {
    return {
      id: null,
      idIcon: null,
      idIconActivityTypes: null,
      activityType: null,
      date: null,
      text: '',
      timeStart: null,
      timeEnd: null,
      selectedChildren: [],
      selectedPredefinedText: null,
      error: null,
    }
  },
  computed: {
    icons () {
      return this.getActivityTypeIcons()
    }
  },
  watch: {
    saveActivity (val) {
      if (val === true) {
        this.setActivity()
      }
    },
    selectedPredefinedText (newText) {
      if (newText === null) {
        return
      }
      this.text = newText
    }
  },
  created () {
    if (this.activity) {
      this.setIdIcon(this.activity.icon_id)

      if (this.idIconActivityTypes) {
        var activityType = this.idIconActivityTypes.find(obj => {
          return obj.id === this.activity.activity_id
        })

        if (activityType) {
          this.setActivityType(activityType)
        }
      }

      this.text = this.activity.text
      this.id = this.activity.id
      this.date = this.activity.date
      this.timeStart = this.activity.start_time.substr(0, 5) || null
      if (this.activity.end_time !== null) {
        this.timeEnd = this.activity.end_time.substr(0, 5)
      } else {
        this.timeEnd = null
      }
      this.selectedChildren = this.activity.child_id
    } else {
      this.id = null
      this.idIcon = null
      this.idIconActivityTypes = null
      this.activityType = null
      this.date = this.$moment().format('YYYY-MM-DD')
      this.text = ''
      this.timeStart = this.$moment().format('HH:mm')
      this.timeEnd = null
      this.selectedChildren = []
    }
  },
  methods: {
    setIdIcon (id) {
      this.activityType = null
      this.idIconActivityTypes = this.getActivityTypesByIdIcon(id)
      if (this.idIconActivityTypes.length === 1) {
        this.activityType = this.idIconActivityTypes[0]
      }
    },
    setActivityType (type) {
      this.activityType = type
    },
    setStartTime (time) {
      this.timeStart = time
    },
    setEndTime (time) {
      this.timeEnd = time
    },
    setDate (date) {
      this.date = this.$moment(date).format('YYYY-MM-DD')
    },
    setChildren (children) {
      this.selectedChildren = children
    },
    collectChildIds () {
      var ids = ''
      if (this.child) {
        ids += this.child.id_child || this.child.id
      } else {
        for (var i = 0; i < this.selectedChildren.length; i++) {
          ids += this.selectedChildren[i].id + ','
        }
      }
      return ids
    },
    setActivity () {
      this.$emit('saveLoading', true);
      if (this.id) {
        this.$request.put('/activities/' + this.id, {
          activity_id: this.activityType.id,
          text: this.text,
          date: this.date,
          start_time: this.timeStart,
          end_time: this.timeEnd
        })
        .then((response) => {
            if (response.error) {
                this.$emit('saveLoading', false)
                this.error = {message: 'Het opslaan is mislukt, probeer het opnieuw'}
            } else {
                this.error = null;
                this.$store.dispatch('getGroupActivities')
                this.$emit('saveActivity', false)
            }
        })
      } else {
        var childIds = this.collectChildIds()
        this.$request.post('/activities', {
          child_id: childIds,
          activity_id: this.activityType.id,
          text: this.text,
          date: this.date,
          start_time: this.timeStart,
          end_time: this.timeEnd
        })
        .then((response) => {
            if (response.error) {
                this.$emit('saveLoading', false)
                this.error = {message: 'Het opslaan is mislukt, probeer het opnieuw'}
            } else {
                this.error = null;
                this.$store.dispatch('getGroupActivities')
                this.appendChildrenById(childIds.split(','))
                this.$emit('saveActivity', false)
            }
        })
      }
    }
  }
}
</script>

<style scoped>
</style>
